//react
import React from 'react';

//redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { StudentCreated, StudentUpdated } from 'redux/actions';

//firebase
import { db, storage } from 'assets/firebase';

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

//core
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import IconButton from "@material-ui/core/IconButton";

//components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
//import CustomSelect from "components/Select/Select.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import PhotoCard from "components/PhotoCard/PhotoCard.jsx";

// @material-ui/icons
import Edit from "@material-ui/icons/Edit";
import Face from "@material-ui/icons/FaceOutlined";
import Photos from "@material-ui/icons/PhotoCameraOutlined";

//fileUploader
import FileUploader from 'react-firebase-file-uploader';

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-127392840-1');

//unique id generator
const uuidv4 = require('uuid/v4');

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

class StudentEditor extends React.Component {

    constructor(props) {
      super(props);

      this.state = {
        modal: false,
        student: props.student
      };

      this.saveStudent = this.saveStudent.bind(this);
      this.updateStudent = this.updateStudent.bind(this);

      this.deletePhoto = this.deletePhoto.bind(this);
      this.updatePhoto = this.updatePhoto.bind(this);
      this.makeCoverPhoto = this.makeCoverPhoto.bind(this);
      this.makeThumbPhoto = this.makeThumbPhoto.bind(this);
    }
    
    handleClickOpen(modal) {
      
      this.updateStudent('ClassID',this.props.classID);
      this.updateStudent('UserType',this.props.userType);

      var x = [];
      x[modal] = true;
      this.setState(x);
    }

    handleClose(modal) {
      var x = [];
      x[modal] = false;
      this.setState(x);
    }

    updateStudent(property, value) {
      var student = this.state.student;
      student[property] = value;
      this.setState({student: student});
    }

    addPhoto(url) {

      var student = this.state.student;
      if(!student.Photos) {
        student.Photos = [];
      }

      var photo = { ID: uuidv4(), Name: "New Photo", Description: "description", URL: url, Attribution:"", License:"", isCover: false, isThumb: false};

      student.Photos.push(photo);
      this.setState({student:student});
    }

    updatePhoto(photo) {
      var student = this.state.student;
      
      for(var i = 0; i < student.Photos.length; i++) {
        if(student.Photos[i].ID === photo.ID) {
          student.Photos[i] = photo;
          break;
        }
      }
    }

    deletePhoto(photo) {
      var student = this.state.student;

      for(var i = student.Photos.length - 1; i > -1; i--) {
        if(student.Photos[i].ID === photo.ID) {
          student.Photos.splice(i,1);
          break;
        }
      }

      this.setState({student:student});
    }

    makeCoverPhoto(photo) {
      var student = this.state.student;
      
      for(var i = 0; i < student.Photos.length; i++) {
        if(student.Photos[i].ID === photo.ID) {
          student.Photos[i].isCover = true;
        } else {
          student.Photos[i].isCover = false;
        }
      }
    }

    makeThumbPhoto(photo) {
      var student = this.state.student;
      
      for(var i = 0; i < student.Photos.length; i++) {
        if(student.Photos[i].ID === photo.ID) {
          student.Photos[i].isThumb = true;
        } else {
          student.Photos[i].isThumb = false;
        }
      }
    }

    showPasswordPrompt() {
      if(this.state.student.id) {
        return "none";
      } else {
        return "block";
      }
    }

    saveStudent() {
      
      db.updateUser(this.state.student.id, this.state.student).then(doc => {
        
        if(!this.state.student.id) { // i.e. if it's a new student

          this.updateStudent("id", doc.id);

          var data = {
            uid: doc.id,
            email: this.state.student.EmailAddress,
            fullName: this.state.student.FirstName + " " + this.state.student.LastName,
            password: this.state.student.Password,
            userName: this.state.student.UserName,
            userType: this.props.userType
          }
          
          fetch("https://us-central1-keiki-262db.cloudfunctions.net/createUser", {
            method: "POST", 
            cache: "no-cache",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
          })
          .then((response) => {
              if(response.ok) {
                  return response.json()
              } else {
                console.log("error1");  
                console.log(response);
              }
          })
          .then((json) => {
              
          })
          .catch((error) => {
              // If there is any error you will catch them here
              console.log("error2: " + error);
          });

          this.props.onStudentCreated(this.state.student);

          ReactGA.event({
            category: 'Student',
            action: 'Created a New Student'
          });

          // reset to blank
          this.setState({student:{
            FirstName: "",
            LastName: "",
            EmailAddress: "",
            Password: "",
            UserName: "",
            Photos: [],
            UserType: this.props.userType,
            ClassID: this.props.classID,
            orgId: this.props.org.id
          }});

        } else { // i.e. an existing student

          this.props.onStudentUpdated(this.state.student);
          ReactGA.event({
            category: 'Student',
            action: 'Updated a Student'
          });
        }

        this.props.onChange();
      });
    }
        
    // photos
    photoUploadStart = () => this.setState({isUploading: true, progress: 0});
    photoUploadProgress = (progress) => this.setState({progress});
    photoUploadError = (error) => {
        this.setState({isUploading: false});
        console.error(error);
    }
    photoUploadSuccess = (filename) => {
        this.setState({progress: 100, isUploading: false});
        
        storage.images.child(filename).getDownloadURL().then(url => this.addPhoto(url));
    };


    trim(value, maxLength) {
      if(value.length > maxLength)
          return value.substring(0,maxLength) + "...";
      else
          return value;
    }

    userTypeDisplay() {
      if(this.props.userType === "teacher") 
        return "Teacher";
      else if (this.props.userType === "student")
        return "Student";
    }

    render() {

      const { classes } = this.props;

      return (
        <div>
          <IconButton
            aria-label="Edit"
            onClick={() => this.handleClickOpen("modal")}>
            <Edit
                className={
                    classes.tableActionButtonIcon + " " + classes.edit
                }
            />
          </IconButton>
          <Dialog
            classes={{
              root: classes.center,
              paper: classes.modal
            }}
            open={this.state.modal}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => this.handleClose("modal")}
            aria-labelledby="modal-slide-title"
            aria-describedby="modal-slide-description">

            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{backgroundColor:"#efefef"}} >

              <GridContainer direction="row">
                <GridItem xs={12} sm={12} md={6}>
                  <h4 className={classes.modalTitle}>Edit {this.userTypeDisplay()}</h4>
                </GridItem>
                <GridItem xs={12} sm={12} md={6} style={{textAlign:"right"}}>
                  
                </GridItem>
              </GridContainer>
            </DialogTitle>
            <DialogContent
              id="modal-slide-description"
              className={classes.modalBody}
              style={{backgroundColor:"#efefef"}}>
             <CustomTabs
                headerColor="success"
                tabs={[
                  {
                    tabName: "General",
                    tabIcon: Face,
                    tabContent: (
                      
                        <GridContainer direction="row">
                          <GridItem xs={12} sm={12} md={6}>
                            <CustomInput
                              id="firstName"
                              labelText="First Name"
                              value={this.state.student.FirstName}
                              inputProps={{
                                  placeholder: "First Name"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateStudent("FirstName", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <CustomInput
                                id="lastName"
                                labelText="Last Name"
                                value={this.state.student.LastName}
                                inputProps={{
                                    placeholder: "Last Name"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateStudent("LastName", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                            <CustomInput
                                id="email"
                                labelText="Email Address"
                                value={this.state.student.EmailAddress}
                                inputProps={{
                                    placeholder: "Email Address"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateStudent("EmailAddress", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <CustomInput
                                id="userName"
                                labelText="User Name"
                                value={this.state.student.UserName}
                                inputProps={{
                                    placeholder: "User Name"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateStudent("UserName", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6} style={{display:this.showPasswordPrompt()}}>
                            <CustomInput
                                id="password"
                                labelText="Initial Password"
                                value={this.state.student.Password}
                                inputProps={{
                                    placeholder: "Initial Password",
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateStudent("Password", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6} >
                            <CustomInput
                                labelText="Parent Email"
                                value={this.state.student.ParentEmail}
                                inputProps={{
                                    placeholder: "Parent Email",
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateStudent("ParentEmail", e.target.value)}
                            />
                          </GridItem>
                          {/*}
                          <GridItem xs={12} sm={12} md={12}>
                              <CustomSelect
                                id="shirtSize"
                                labelText="Shirt Size"
                                value={this.state.student.ShirtSize}
                                inputProps={{
                                    placeholder: "Shirt Size"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateStudent("ShirtSize", e.target.value)}
                                options={[
                                  { key: "ySmall", label:"Youth Small"},
                                  { key: "yMedium", label:"Youth Medium"},
                                  { key: "yLarge", label:"Youth Large"},
                                  { key: "aSmall", label:"Adult Small"},
                                  { key: "aMedium", label:"Adult Medium"},
                                  { key: "aLarge", label:"Adult Large"}
                                ]}
                               />
                          </GridItem>
                          */}
                        </GridContainer>
                    )
                  },
                  {
                    tabName: "Photos",
                    tabIcon: Photos,
                    tabContent: (

                      <div>
                        <div style={{marginTop:"10px"}}>

                          <label style={{color: "#696969", cursor:"pointer"}}>
                            Upload a New Photo  
                          
                            <FileUploader
                              hidden 
                              accept="image/*"
                              name="photo"
                              randomizeFilename
                              storageRef={storage.images}
                              onUploadStart={this.photoUploadStart}
                              onUploadError={this.photoUploadError}
                              onUploadSuccess={this.photoUploadSuccess}
                              onProgress={this.photoUploadProgress}
                              />
                              
                          </label>
                        </div>

                        <GridContainer justify="flex-start">
                          {this.state.student.Photos.map(photo => (
                              <PhotoCard key={photo.id} photo={photo} 
                                onPhotoUpdated={this.updatePhoto} onPhotoMakeCover={this.makeCoverPhoto} 
                                onPhotoMakeThumb={this.makeThumbPhoto} onPhotoDelete={this.deletePhoto} />
                          ))}
                        </GridContainer>
                      </div>
                    )
                  }
                ]}
              />

            </DialogContent>
            
            <DialogActions
              className={classes.modalFooter }
              style={{backgroundColor:"#efefef"}}>
              <Button
                    onClick={() => this.handleClose("modal")}
                  >
                    Cancel
                  </Button>
                  &nbsp;
                  <Button
                    onClick={() => {
                        this.saveStudent();
                        this.handleClose("modal");
                      }}
                    color="success">
                    Save
                  </Button>
            </DialogActions>
          </Dialog>
        </div>
      );
    }
}
  
const mapStateToProps = state => {
  return state;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({onStudentCreated: StudentCreated, onStudentUpdated: StudentUpdated }, dispatch);  
}

StudentEditor = connect(mapStateToProps, mapDispatchToProps)(StudentEditor);
export default withStyles(modalStyle)(StudentEditor);


// WEBPACK FOOTER //
// ./src/components/StudentEditor/StudentEditor.jsx